module.exports = __webpack_public_path__ + "static/media/twitter.c8eee7b8.svg";